import { EmptyResult } from '@package/services/src/Result'

import { CheckoutPaymentFormData } from '../types'

import { AffirmPaymentService } from './services'

export default class AffirmPaymentInteractor {
  public constructor(
    private affirmPaymentService: AffirmPaymentService,
  ) { }

  private getAffirm() {
    return typeof window !== 'undefined' ? window.affirm : undefined
  }

  public async checkout(
    request: CheckoutPaymentFormData
  ): Promise<EmptyResult> {
    const affirm = this.getAffirm()

    if (!affirm) throw new Error('Affirm script not found')

    const { data: affirmCheckoutObject } =
      await this.affirmPaymentService.createCheckoutObject()

    return new Promise((resolve) => {
      affirm.ui.ready(() => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        affirm.checkout(affirmCheckoutObject)
        affirm.checkout.open({
          onSuccess: (response) => {
            resolve(
              this.affirmPaymentService.checkout({
                affirmCheckoutToken: response.checkout_token,
              })
            )
          },
          onFail: () =>
            console.info('User cancelled the Affirm checkout flow'),
        })
      })
    })
  }
}
